export const USER_SESSIONS = '/user-sessions'
